import { render } from "./WaterStewardship.vue?vue&type=template&id=45a5f164&scoped=true"
import script from "./WaterStewardship.vue?vue&type=script&lang=js"
export * from "./WaterStewardship.vue?vue&type=script&lang=js"

import "./WaterStewardship.vue?vue&type=style&index=0&id=45a5f164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a5f164"]])

export default __exports__